import * as _api from './api'
import { createBrowserHistory } from 'history'

export const api = _api
export const history = createBrowserHistory()
